// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderInfoModal_btn__6J4Rx {
  width: 100%;
  height: 44px;
  border-radius: 12px;
  background-color: var(--accent-color);
  transition: 0.2s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  color: var(--accent-text-color);
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 1;
  position: relative;
}
@media (hover: hover) {
  .OrderInfoModal_btn__6J4Rx:hover {
    opacity: 0.8;
  }
}
@media (min-width: 640px) {
  .OrderInfoModal_btn__6J4Rx {
    font-size: 20px;
    height: 76px;
  }
}
@media (min-width: 1200px) {
  .OrderInfoModal_btn__6J4Rx {
    font-size: 12px;
    width: auto;
    height: 36px;
    padding: 0 32px;
  }
}
.OrderInfoModal_btn__6J4Rx:disabled {
  cursor: default;
  pointer-events: none;
  background-color: #EEEEEE;
  color: rgba(21, 27, 38, 0.4);
}
.OrderInfoModal_btn__loader__3-5In, .OrderInfoModal_btn__icon__C1fYm {
  position: absolute;
  transform: translateY(-50%);
  right: 12px;
  width: 16px;
  height: 16px;
  transform-origin: center;
}
.OrderInfoModal_btn__loader__3-5In {
  top: 50%;
  animation: OrderInfoModal_loader__t6pGl 2s infinite linear;
  display: none;
}
.OrderInfoModal_btn__icon__C1fYm {
  top: calc(50% + 2px);
}
@media (min-width: 1200px) {
  .OrderInfoModal_btn__icon__C1fYm {
    display: flex;
  }
}
.OrderInfoModal_btn--is-loading__TMIAL {
  pointer-events: none;
}
.OrderInfoModal_btn--is-loading__TMIAL .OrderInfoModal_btn__loader__3-5In {
  display: inline-block;
}
.OrderInfoModal_btn--is-loading__TMIAL .OrderInfoModal_btn__loader__3-5In + .OrderInfoModal_btn__icon__C1fYm {
  display: none;
}
.OrderInfoModal_btn--gray__Cj3Tn {
  background: #EEEEEE;
  color: var(--text-color);
}
.OrderInfoModal_btn--warning__Gw2bN {
  background: linear-gradient(87.49deg, #FA7B45 -0.07%, #F44C4C 95.73%);
}
.OrderInfoModal_btn--white__TYUGD {
  background-color: var(--white);
  color: var(--text-color);
}
@media (hover: hover) {
  .OrderInfoModal_btn--white__TYUGD:hover {
    background-color: var(--accent-color);
    color: var(--accent-text-color);
  }
}
.OrderInfoModal_btn--light__JZr28 {
  background-color: rgba(var(--accent-color-rgb), 0.12);
  color: var(--accent-color);
}
@media (hover: hover) {
  .OrderInfoModal_btn--light__JZr28:hover {
    background-color: var(--accent-color);
    color: var(--accent-text-color);
  }
}
.OrderInfoModal_btn--sm-width__0K6u0 {
  width: 94px;
  min-width: 94px;
}
.OrderInfoModal_btn--sm__Eg9Qd {
  height: 32px;
}
@media (min-width: 1200px) {
  .OrderInfoModal_btn--sm__Eg9Qd {
    padding-left: 16px;
    padding-right: 16px;
  }
}
.OrderInfoModal_btn--md__RPJAJ {
  height: 66px;
}
@media (min-width: 640px) {
  .OrderInfoModal_btn--md__RPJAJ {
    height: 76px;
    font-size: 20px;
  }
}
@media (min-width: 1200px) {
  .OrderInfoModal_btn--md__RPJAJ {
    height: 44px;
    font-size: 12px;
    line-height: normal;
  }
}
.OrderInfoModal_btn--xsm__-5YYJ {
  height: 44px;
  border-radius: 12px;
  padding-left: 18px;
  padding-right: 18px;
}
@media (min-width: 1200px) {
  .OrderInfoModal_btn--xsm__-5YYJ {
    height: 24px;
    border-radius: 6px;
    line-height: normal;
  }
}

@keyframes OrderInfoModal_loader__t6pGl {
  0% {
    transform: translateY(-50%) rotate(0deg);
  }
  0% {
    transform: translateY(-50%) rotate(360deg);
  }
  100% {
    transform: translateY(-50%) rotate(0deg);
  }
}
.OrderInfoModal_btnClose__1C1Bb {
  width: 28px;
  height: 28px;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  background-color: var(--gray-20);
  color: var(--gray-180);
  margin-left: auto;
  transition: var(--transition);
  transition-property: background-color, opacity;
}
@media (hover: hover) {
  .OrderInfoModal_btnClose__1C1Bb:hover {
    opacity: 0.8;
  }
}

.OrderInfoModal_title__NYXap {
  min-height: 24px;
  min-width: 200px;
  border-radius: 8px;
}
.OrderInfoModal_title__NYXap::first-letter {
  text-transform: capitalize;
}
.OrderInfoModal_title__NYXap.skeletonBlock {
  font-size: 0;
}
.OrderInfoModal_title__NYXap span {
  font-weight: normal;
}

.OrderInfoModal_main__c32tA {
  display: flex;
}

.OrderInfoModal_aside__cnk7K {
  width: var(--modal-aside-width);
  flex-shrink: 0;
  border-right: 1px solid #E0E7EB;
  display: flex;
  flex-direction: column;
}

.OrderInfoModal_aside-lg__ohIJT {
  width: var(--modal-aside-width-lg);
}

.OrderInfoModal_footer__qgwsZ {
  display: flex;
  justify-content: flex-end;
  padding-bottom: 24px;
  margin-top: auto;
}
@media (min-width: 1200px) {
  .OrderInfoModal_footer__qgwsZ {
    border-top: 1px solid #E0E7EB;
    min-height: var(--modal-footer-height);
    padding: 8px 8px 7px;
  }
}
.OrderInfoModal_footer__qgwsZ.OrderInfoModal_footer__painted__JYqju {
  background: #FAFAFA;
  padding: 12px;
  border-bottom-left-radius: 16px;
}
@media (max-width: 1200px) {
  .OrderInfoModal_footer__qgwsZ.OrderInfoModal_footer__painted__JYqju {
    background: none;
    padding: 0 0 16px;
  }
}
.OrderInfoModal_footer__qgwsZ.OrderInfoModal_column__vTjNF {
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}
.OrderInfoModal_footer__qgwsZ.OrderInfoModal_column__vTjNF button {
  padding: 12px;
  width: max-content;
  height: 36px;
}
.OrderInfoModal_footer__qgwsZ.OrderInfoModal_column__vTjNF .coordination-footer {
  padding-bottom: 8px;
  border-bottom: 1px solid #E0E7EB;
}

.OrderInfoModal_dummyChat__MIHUe {
  min-height: 592px;
  width: 100%;
}

.OrderInfoModal_dummyChat__MIHUe {
  background-color: var(--white);
}

.OrderInfoModal_img__rIOqs {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 100%;
  overflow: hidden;
  flex-shrink: 0;
  margin-right: 15px;
}

.OrderInfoModal_active-or-history-modal__gZov\\+ {
  padding: 0;
}
.OrderInfoModal_active-or-history-modal__gZov\\+ .modal__inner {
  max-width: none;
  border-radius: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.OrderInfoModal_active-or-history-modal__gZov\\+ .modal__inner .modal__header {
  padding: 0 0 12px 0;
  min-height: max-content;
  margin: 24px 16px 16px;
}
.OrderInfoModal_active-or-history-modal__gZov\\+ .modal__inner .modal__header .titleBack__back {
  width: 36px;
  height: 36px;
}
.OrderInfoModal_active-or-history-modal__gZov\\+ .modal__inner .modal__body {
  flex-grow: 1;
  display: flex;
}
.OrderInfoModal_active-or-history-modal__gZov\\+.OrderInfoModal_opened-mobile-chat__e\\+tgm .modal__inner {
  padding: 0;
}
.OrderInfoModal_active-or-history-modal__gZov\\+.OrderInfoModal_opened-mobile-chat__e\\+tgm .modal__inner .modal__header {
  padding: 16px;
  margin: 0;
}
.OrderInfoModal_active-or-history-modal__gZov\\+ .OrderInfoModal_main__c32tA {
  flex-grow: 1;
}
.OrderInfoModal_active-or-history-modal__gZov\\+ .OrderInfoModal_aside__cnk7K {
  width: 100%;
  border: none;
}
.OrderInfoModal_active-or-history-modal__gZov\\+ .OrderInfoModal_btn-container__FahOu {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: auto;
  gap: 8px;
  padding: 16px 24px;
}
.OrderInfoModal_active-or-history-modal__gZov\\+ .OrderInfoModal_btn-container__FahOu button {
  height: 44px;
}
@media (min-width: 640px) {
  .OrderInfoModal_active-or-history-modal__gZov\\+ .OrderInfoModal_btn-container__FahOu button {
    height: 54px;
  }
}
.OrderInfoModal_active-or-history-modal__gZov\\+ .OrderInfoModal_btn-container__FahOu .btn_orange {
  margin-bottom: 16px;
}
.OrderInfoModal_active-or-history-modal__gZov\\+ .OrderInfoModal_btn-container__topTwoBtns__WJTXC {
  display: flex;
  gap: 8px;
}
.OrderInfoModal_active-or-history-modal__gZov\\+ .OrderInfoModal_btn-container__bottomTwoBtns__XMs8m {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.OrderInfoModal_active-or-history-modal__gZov\\+ .OrderInfoModal_btn-container__bottomTwoBtns__XMs8m .OrderInfoModal_back-btn__Eql11 {
  width: 50%;
}
.OrderInfoModal_active-or-history-modal__gZov\\+ .OrderInfoModal_btn-container__bottomTwoBtns__XMs8m .OrderInfoModal_messenger-btn__Pea6W {
  gap: 4px;
}

.OrderInfoModal_mobile-chat__3WOOC {
  width: 100%;
  position: initial;
}

.OrderInfoModal_messagesNoReview__0Kbc4 {
  position: absolute;
  top: -10px;
  right: -10px;
  font-size: 11px;
  line-height: 11px;
  background: #FF3C3C;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  border: 2px solid #FAFAFA;
  color: #FAFAFA;
  display: flex;
  align-items: center;
  justify-content: center;
}

.OrderInfoModal_no-margin-closeBtn__82MZF .modal__close-btn {
  margin-left: 16px;
}

.OrderInfoModal_labelInfo__nzteu {
  margin-left: auto;
}

.OrderInfoModal_pdfBlock__FFRHN {
  margin-left: auto;
}
.OrderInfoModal_pdfBlock__btn__Yp8HG {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1px;
  background: #DBECFA;
  padding: 5px 12px;
  font-weight: 500;
  font-size: 12px;
  line-height: 100%;
  height: 28px;
  color: #177FD2;
  border-radius: 40px;
  transition: 0.2s;
  gap: 2px;
  position: relative;
  white-space: nowrap;
  margin-right: 4px;
}
@media (hover: hover) {
  .OrderInfoModal_pdfBlock__btn__Yp8HG:hover {
    background: #C7E1F7;
  }
}
.OrderInfoModal_pdfBlock__btn__Yp8HG svg {
  width: 16px;
  height: 16px;
}
.OrderInfoModal_pdfBlock__btn__Yp8HG .btn__loader {
  display: block;
  right: 0;
}
.OrderInfoModal_pdfBlock__btn__Yp8HG.OrderInfoModal_loading__X4mJt {
  color: hsla(207, 80%, 46%, 0.6);
  cursor: initial;
  background: #DBECFA;
}
.OrderInfoModal_pdfBlock__loaderWp__BbMTh {
  position: relative;
  width: 16px;
  height: 16px;
}
.OrderInfoModal_pdfBlock__download__lg24L {
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: var(--text-color);
  padding: 6px 12px;
  background: #FAFAFA;
  text-decoration: none;
  border-radius: 22px;
  height: 28px;
  transition: 0.2s;
}
.OrderInfoModal_pdfBlock__download__lg24L img {
  max-height: 16px;
}
@media (hover: hover) {
  .OrderInfoModal_pdfBlock__download__lg24L:hover {
    background: #F0F1F5;
  }
}

.OrderInfoModal_mobHeaderFlex__68sV0 {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}`, "",{"version":3,"sources":["webpack://./src/components/Assets/Button/Button.module.scss","webpack://./src/components/Modals/OrderInfoModal/OrderInfoModal.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;ACCF;ADCE;EACE;IACE,YAAA;ECCJ;AACF;ADEE;EAvBF;IAwBI,eAAA;IACA,YAAA;ECCF;AACF;ADCE;EA5BF;IA6BI,eAAA;IACA,WAAA;IACA,YAAA;IACA,eAAA;ECEF;AACF;ADAE;EACE,eAAA;EACA,oBAAA;EACA,yBAAA;EACA,4BAAA;ACEJ;ADCE;EAEE,kBAAA;EACA,2BAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;ACAJ;ADGE;EACE,QAAA;EACA,0DAAA;EACA,aAAA;ACDJ;ADIE;EACE,oBAAA;ACFJ;ADII;EAHF;IAII,aAAA;ECDJ;AACF;ADIE;EACE,oBAAA;ACFJ;ADKM;EACE,qBAAA;ACHR;ADMU;EACE,aAAA;ACJZ;ADWE;EACE,mBAAA;EACA,wBAAA;ACTJ;ADYE;EACE,qEAAA;ACVJ;ADaE;EACE,8BAAA;EACA,wBAAA;ACXJ;ADaI;EACE;IACE,qCAAA;IACA,+BAAA;ECXN;AACF;ADeE;EACE,qDAAA;EACA,0BAAA;ACbJ;ADeI;EACE;IACE,qCAAA;IACA,+BAAA;ECbN;AACF;ADiBE;EACE,WAAA;EACA,eAAA;ACfJ;ADkBE;EACE,YAAA;AChBJ;ADkBI;EAHF;IAII,kBAAA;IACA,mBAAA;ECfJ;AACF;ADkBE;EACE,YAAA;AChBJ;ADkBI;EAHF;IAII,YAAA;IACA,eAAA;ECfJ;AACF;ADiBI;EARF;IASI,YAAA;IACA,eAAA;IACA,mBAAA;ECdJ;AACF;ADiBE;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;ACfJ;ADiBI;EANF;IAOI,YAAA;IACA,kBAAA;IACA,mBAAA;ECdJ;AACF;;ADkBA;EACE;IACE,wCAAA;ECfF;EDiBA;IACE,0CAAA;ECfF;EDiBA;IACE,wCAAA;ECfF;AACF;AAtJA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,gCAAA;EACA,sBAAA;EACA,iBAAA;EACA,6BAAA;EACA,8CAAA;AAwJF;AAtJE;EACE;IACE,YAAA;EAwJJ;AACF;;AApJA;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;AAuJF;AArJE;EACE,0BAAA;AAuJJ;AApJE;EACE,YAAA;AAsJJ;AAnJE;EACE,mBAAA;AAqJJ;;AAjJA;EACE,aAAA;AAoJF;;AAjJA;EACE,+BAAA;EACA,cAAA;EACA,+BAAA;EACA,aAAA;EACA,sBAAA;AAoJF;;AAjJA;EACE,kCAAA;AAoJF;;AAjJA;EACE,aAAA;EACA,yBAAA;EACA,oBAAA;EACA,gBAAA;AAoJF;AAlJE;EANF;IAOI,6BAAA;IACA,sCAAA;IACA,oBAAA;EAqJF;AACF;AAnJE;EACE,mBAAA;EACA,aAAA;EACA,+BAAA;AAqJJ;AAnJI;EALF;IAMI,gBAAA;IACA,iBAAA;EAsJJ;AACF;AAnJE;EACE,sBAAA;EACA,qBAAA;EACA,QAAA;AAqJJ;AAnJI;EACE,aAAA;EACA,kBAAA;EACA,YAAA;AAqJN;AAjJM;EACE,mBAAA;EACA,gCAAA;AAmJR;;AA7IA;EACE,iBAAA;EACA,WAAA;AAgJF;;AA7IA;EACE,8BAAA;AAgJF;;AA7IA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAgJF;;AA7IA;EACE,UAAA;AAgJF;AA7II;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;AA+IN;AA7IM;EACE,mBAAA;EACA,uBAAA;EACA,sBAAA;AA+IR;AA7IQ;EACE,WAAA;EACA,YAAA;AA+IV;AA3IM;EAIE,YAAA;EACA,aAAA;AA0IR;AAnIM;EACE,UAAA;AAqIR;AAnIQ;EACE,aAAA;EACA,SAAA;AAqIV;AA/HE;EAIE,YAAA;AA8HJ;AA3HE;EACE,WAAA;EACA,YAAA;AA6HJ;AA1HE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,QAAA;EACA,kBAAA;AA4HJ;AA1HI;EACE,YAAA;AA4HN;AA1HM;EAHF;IAII,YAAA;EA6HN;AACF;AAzHM;EACE,mBAAA;AA2HR;AAvHI;EACE,aAAA;EACA,QAAA;AAyHN;AAtHI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AAwHN;AAtHM;EACE,UAAA;AAwHR;AArHM;EACE,QAAA;AAuHR;;AAjHA;EAIE,WAAA;EACA,iBAAA;AAiHF;;AA9GA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAiHF;;AA5GI;EACE,iBAAA;AA+GN;;AA1GA;EACE,iBAAA;AA6GF;;AA1GA;EACE,iBAAA;AA6GF;AA5GE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AA8GJ;AA5GI;EACE;IACE,mBAAA;EA8GN;AACF;AA3GI;EACE,WAAA;EACA,YAAA;AA6GN;AAzGM;EACE,cAAA;EACA,QAAA;AA2GR;AAvGI;EACE,+BAAA;EACA,eAAA;EACA,mBAAA;AAyGN;AAtGE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AAwGJ;AArGE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AAuGJ;AArGI;EACE,gBAAA;AAuGN;AApGI;EACE;IACE,mBAAA;EAsGN;AACF;;AAjGA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAoGF","sourcesContent":[".btn {\r\n  width: 100%;\r\n  height: 44px;\r\n  border-radius: 12px;\r\n  background-color: var(--accent-color);\r\n  transition: 0.2s;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 12px 16px;\r\n  color: var(--accent-text-color);\r\n  font-size: 12px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 1;\r\n  position: relative;\r\n\r\n  @media (hover: hover) {\r\n    &:hover {\r\n      opacity: 0.8;\r\n    }\r\n  }\r\n\r\n  @media (min-width: 640px) {\r\n    font-size: 20px;\r\n    height: 76px;\r\n  }\r\n\r\n  @media (min-width: 1200px) {\r\n    font-size: 12px;\r\n    width: auto;\r\n    height: 36px;\r\n    padding: 0 32px;\r\n  }\r\n\r\n  &:disabled {\r\n    cursor: default;\r\n    pointer-events: none;\r\n    background-color: #EEEEEE;\r\n    color: rgba(#151B26, 0.4)\r\n  }\r\n\r\n  &__loader,\r\n  &__icon {\r\n    position: absolute;\r\n    transform: translateY(-50%);\r\n    right: 12px;\r\n    width: 16px;\r\n    height: 16px;\r\n    transform-origin: center;\r\n  }\r\n\r\n  &__loader {\r\n    top: 50%;\r\n    animation: loader 2s infinite linear;\r\n    display: none;\r\n  }\r\n\r\n  &__icon {\r\n    top: calc(50% + 2px);\r\n\r\n    @media (min-width: 1200px) {\r\n      display: flex;\r\n    }\r\n  }\r\n\r\n  &--is-loading {\r\n    pointer-events: none;\r\n\r\n    .btn {\r\n      &__loader {\r\n        display: inline-block;\r\n\r\n        & + .btn {\r\n          &__icon {\r\n            display: none;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  &--gray {\r\n    background: #EEEEEE;\r\n    color: var(--text-color);\r\n  }\r\n\r\n  &--warning {\r\n    background: linear-gradient(87.49deg, #FA7B45 -0.07%, #F44C4C 95.73%);\r\n  }\r\n\r\n  &--white {\r\n    background-color: var(--white);\r\n    color: var(--text-color);\r\n\r\n    @media (hover: hover) {\r\n      &:hover {\r\n        background-color: var(--accent-color);\r\n        color: var(--accent-text-color);\r\n      }\r\n    }\r\n  }\r\n\r\n  &--light {\r\n    background-color: rgba(var(--accent-color-rgb), 0.12);\r\n    color: var(--accent-color);\r\n\r\n    @media (hover: hover) {\r\n      &:hover {\r\n        background-color: var(--accent-color);\r\n        color: var(--accent-text-color);\r\n      }\r\n    }\r\n  }\r\n\r\n  &--sm-width {\r\n    width: 94px;\r\n    min-width: 94px;\r\n  }\r\n\r\n  &--sm {\r\n    height: 32px;\r\n\r\n    @media (min-width: 1200px) {\r\n      padding-left: 16px;\r\n      padding-right: 16px;\r\n    }\r\n  }\r\n\r\n  &--md {\r\n    height: 66px;\r\n\r\n    @media (min-width: 640px) {\r\n      height: 76px;\r\n      font-size: 20px;\r\n    }\r\n\r\n    @media (min-width: 1200px) {\r\n      height: 44px;\r\n      font-size: 12px;\r\n      line-height: normal;\r\n    }\r\n  }\r\n\r\n  &--xsm {\r\n    height: 44px;\r\n    border-radius: 12px;\r\n    padding-left: 18px;\r\n    padding-right: 18px;\r\n\r\n    @media (min-width: 1200px) {\r\n      height: 24px;\r\n      border-radius: 6px;\r\n      line-height: normal;\r\n    }\r\n  }\r\n}\r\n\r\n@keyframes loader {\r\n  0% {\r\n    transform: translateY(-50%) rotate(0deg);\r\n  }\r\n  0% {\r\n    transform: translateY(-50%) rotate(360deg);\r\n  }\r\n  100% {\r\n    transform: translateY(-50%) rotate(0deg);\r\n  }\r\n}\r\n","@import \"../../Assets/Button/Button.module.scss\";\r\n\r\n.btnClose {\r\n  width: 28px;\r\n  height: 28px;\r\n  border-radius: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-shrink: 0;\r\n  background-color: var(--gray-20);\r\n  color: var(--gray-180);\r\n  margin-left: auto;\r\n  transition: var(--transition);\r\n  transition-property: background-color, opacity;\r\n\r\n  @media (hover: hover) {\r\n    &:hover {\r\n      opacity: 0.8;\r\n    }\r\n  }\r\n}\r\n\r\n.title {\r\n  min-height: 24px;\r\n  min-width: 200px;\r\n  border-radius: 8px;\r\n\r\n  &::first-letter {\r\n    text-transform: capitalize;\r\n  }\r\n\r\n  &:global(.skeletonBlock) {\r\n    font-size: 0;\r\n  }\r\n\r\n  span {\r\n    font-weight: normal;\r\n  }\r\n}\r\n\r\n.main {\r\n  display: flex;\r\n}\r\n\r\n.aside {\r\n  width: var(--modal-aside-width);\r\n  flex-shrink: 0;\r\n  border-right: 1px solid #E0E7EB;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.aside-lg {\r\n  width: var(--modal-aside-width-lg);\r\n}\r\n\r\n.footer {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  padding-bottom: 24px;\r\n  margin-top: auto;\r\n\r\n  @media (min-width: 1200px) {\r\n    border-top: 1px solid #E0E7EB;\r\n    min-height: var(--modal-footer-height);\r\n    padding: 8px 8px 7px;\r\n  }\r\n\r\n  &.footer__painted {\r\n    background: #FAFAFA;\r\n    padding: 12px;\r\n    border-bottom-left-radius: 16px;\r\n\r\n    @media (max-width: 1200px) {\r\n      background: none;\r\n      padding: 0 0 16px;\r\n    }\r\n  }\r\n\r\n  &.column {\r\n    flex-direction: column;\r\n    align-items: flex-end;\r\n    gap: 8px;\r\n\r\n    button {\r\n      padding: 12px;\r\n      width: max-content;\r\n      height: 36px;\r\n    }\r\n\r\n    :global {\r\n      .coordination-footer {\r\n        padding-bottom: 8px;\r\n        border-bottom: 1px solid #E0E7EB;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.dummyChat {\r\n  min-height: 592px;\r\n  width: 100%;\r\n}\r\n\r\n.dummyChat {\r\n  background-color: var(--white);\r\n}\r\n\r\n.img {\r\n  width: 40px;\r\n  height: 40px;\r\n  object-fit: cover;\r\n  border-radius: 100%;\r\n  overflow: hidden;\r\n  flex-shrink: 0;\r\n  margin-right: 15px;\r\n}\r\n\r\n.active-or-history-modal {\r\n  padding: 0;\r\n\r\n  :global {\r\n    .modal__inner {\r\n      max-width: none;\r\n      border-radius: 0;\r\n      height: 100%;\r\n      display: flex;\r\n      flex-direction: column;\r\n      overflow: auto;\r\n\r\n      .modal__header {\r\n        padding: 0 0 12px 0;\r\n        min-height: max-content;\r\n        margin: 24px 16px 16px;\r\n\r\n        .titleBack__back {\r\n          width: 36px;\r\n          height: 36px;\r\n        }\r\n      }\r\n\r\n      .modal__body {\r\n        // тест изменения модалки. Если все норм, потом удалить\r\n        // height: 100%;\r\n\r\n        flex-grow: 1;\r\n        display: flex;\r\n      }\r\n    }\r\n  }\r\n\r\n  &.opened-mobile-chat {\r\n    :global {\r\n      .modal__inner {\r\n        padding: 0;\r\n\r\n        .modal__header {\r\n          padding: 16px;\r\n          margin: 0;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .main {\r\n    // тест изменения модалки. Если все норм, потом удалить\r\n    // height: 100%;\r\n\r\n    flex-grow: 1;\r\n  }\r\n\r\n  .aside {\r\n    width: 100%;\r\n    border: none;\r\n  }\r\n\r\n  .btn-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n    margin-top: auto;\r\n    gap: 8px;\r\n    padding: 16px 24px;\r\n    \r\n    button {\r\n      height: 44px;\r\n\r\n      @media (min-width: 640px) {\r\n        height: 54px;\r\n      }\r\n    }\r\n  \r\n    :global {\r\n      .btn_orange {\r\n        margin-bottom: 16px;\r\n      }\r\n    }\r\n\r\n    &__topTwoBtns {\r\n      display: flex;\r\n      gap: 8px;\r\n    }\r\n\r\n    &__bottomTwoBtns {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      gap: 8px;\r\n\r\n      .back-btn {\r\n        width: 50%;\r\n      }\r\n\r\n      .messenger-btn {\r\n        gap: 4px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.mobile-chat {\r\n  // тест изменения модалки. Если все норм, потом удалить\r\n  // position: absolute;\r\n  // height: calc(100% - 69px);\r\n  width: 100%;\r\n  position: initial;\r\n}\r\n\r\n.messagesNoReview {\r\n  position: absolute;\r\n  top: -10px;\r\n  right: -10px;\r\n  font-size: 11px;\r\n  line-height: 11px;\r\n  background: #FF3C3C;\r\n  border-radius: 50%;\r\n  width: 20px;\r\n  height: 20px;\r\n  border: 2px solid #FAFAFA;\r\n  color: #FAFAFA;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.no-margin-closeBtn {\r\n  :global {\r\n    .modal__close-btn {\r\n      margin-left: 16px;\r\n    }\r\n  }\r\n}\r\n\r\n.labelInfo {\r\n  margin-left: auto;\r\n}\r\n\r\n.pdfBlock {\r\n  margin-left: auto;\r\n  &__btn {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 1px;\r\n    background: #DBECFA;\r\n    padding: 5px 12px;\r\n    font-weight: 500;\r\n    font-size: 12px;\r\n    line-height: 100%;\r\n    height: 28px;\r\n    color: #177FD2;\r\n    border-radius: 40px;\r\n    transition: 0.2s;\r\n    gap: 2px;\r\n    position: relative;\r\n    white-space: nowrap;\r\n    margin-right: 4px;\r\n\r\n    @media (hover: hover) {\r\n      &:hover {\r\n        background: #C7E1F7;\r\n      }\r\n    }\r\n\r\n    svg {\r\n      width: 16px;\r\n      height: 16px;\r\n    }\r\n\r\n    :global {\r\n      .btn__loader {\r\n        display: block;\r\n        right: 0;\r\n      }\r\n    }\r\n\r\n    &.loading {\r\n      color: hsla(207, 80%, 46%, 0.6);\r\n      cursor: initial;\r\n      background: #DBECFA;\r\n    }\r\n  }\r\n  &__loaderWp {\r\n    position: relative;\r\n    width: 16px;\r\n    height: 16px;\r\n  }\r\n\r\n  &__download {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 4px;\r\n    font-weight: 400;\r\n    font-size: 12px;\r\n    line-height: 14px;\r\n    color: var(--text-color);\r\n    padding: 6px 12px;\r\n    background: #FAFAFA;\r\n    text-decoration: none;\r\n    border-radius: 22px;\r\n    height: 28px;\r\n    transition: 0.2s;\r\n\r\n    img {\r\n      max-height: 16px;\r\n    }\r\n\r\n    @media (hover: hover) {\r\n      &:hover {\r\n        background: #F0F1F5;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.mobHeaderFlex {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btn": `OrderInfoModal_btn__6J4Rx`,
	"btn__loader": `OrderInfoModal_btn__loader__3-5In`,
	"btn__icon": `OrderInfoModal_btn__icon__C1fYm`,
	"loader": `OrderInfoModal_loader__t6pGl`,
	"btn--is-loading": `OrderInfoModal_btn--is-loading__TMIAL`,
	"btn--gray": `OrderInfoModal_btn--gray__Cj3Tn`,
	"btn--warning": `OrderInfoModal_btn--warning__Gw2bN`,
	"btn--white": `OrderInfoModal_btn--white__TYUGD`,
	"btn--light": `OrderInfoModal_btn--light__JZr28`,
	"btn--sm-width": `OrderInfoModal_btn--sm-width__0K6u0`,
	"btn--sm": `OrderInfoModal_btn--sm__Eg9Qd`,
	"btn--md": `OrderInfoModal_btn--md__RPJAJ`,
	"btn--xsm": `OrderInfoModal_btn--xsm__-5YYJ`,
	"btnClose": `OrderInfoModal_btnClose__1C1Bb`,
	"title": `OrderInfoModal_title__NYXap`,
	"main": `OrderInfoModal_main__c32tA`,
	"aside": `OrderInfoModal_aside__cnk7K`,
	"aside-lg": `OrderInfoModal_aside-lg__ohIJT`,
	"footer": `OrderInfoModal_footer__qgwsZ`,
	"footer__painted": `OrderInfoModal_footer__painted__JYqju`,
	"column": `OrderInfoModal_column__vTjNF`,
	"dummyChat": `OrderInfoModal_dummyChat__MIHUe`,
	"img": `OrderInfoModal_img__rIOqs`,
	"active-or-history-modal": `OrderInfoModal_active-or-history-modal__gZov+`,
	"opened-mobile-chat": `OrderInfoModal_opened-mobile-chat__e+tgm`,
	"btn-container": `OrderInfoModal_btn-container__FahOu`,
	"btn-container__topTwoBtns": `OrderInfoModal_btn-container__topTwoBtns__WJTXC`,
	"btn-container__bottomTwoBtns": `OrderInfoModal_btn-container__bottomTwoBtns__XMs8m`,
	"back-btn": `OrderInfoModal_back-btn__Eql11`,
	"messenger-btn": `OrderInfoModal_messenger-btn__Pea6W`,
	"mobile-chat": `OrderInfoModal_mobile-chat__3WOOC`,
	"messagesNoReview": `OrderInfoModal_messagesNoReview__0Kbc4`,
	"no-margin-closeBtn": `OrderInfoModal_no-margin-closeBtn__82MZF`,
	"labelInfo": `OrderInfoModal_labelInfo__nzteu`,
	"pdfBlock": `OrderInfoModal_pdfBlock__FFRHN`,
	"pdfBlock__btn": `OrderInfoModal_pdfBlock__btn__Yp8HG`,
	"loading": `OrderInfoModal_loading__X4mJt`,
	"pdfBlock__loaderWp": `OrderInfoModal_pdfBlock__loaderWp__BbMTh`,
	"pdfBlock__download": `OrderInfoModal_pdfBlock__download__lg24L`,
	"mobHeaderFlex": `OrderInfoModal_mobHeaderFlex__68sV0`
};
export default ___CSS_LOADER_EXPORT___;
